export default __webpack_public_path__ + "static/media/_class_private_field_init.d4fd5b03.cjs";